import { get, post, put, del } from '../rest';

export default {
  index: params => get('/post_topics', params),
  getPostTopics: params => get('/admin/post_topics', params),
  createPostTopic: params => post('/admin/post_topics', params),
  updatePostTopic: params => put('/admin/post_topics/' + params.id, params),
  deletePostTopic: id => del('/admin/post_topics/' + id),
};
